export class EventEmitter {
  private listeners: Map<string, Set<Function>> = new Map();

  public on(event: string, callback: Function): () => void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }

    const eventListeners = this.listeners.get(event);
    eventListeners?.add(callback);

    return () => {
      eventListeners?.delete(callback);
      if (eventListeners?.size === 0) {
        this.listeners.delete(event);
      }
    };
  }

  public once(event: string, callback: Function): () => void {
    const unsubscribe = this.on(event, (...args: any[]) => {
      unsubscribe();
      callback(...args);
    });

    return unsubscribe;
  }

  public emit(event: string, ...args: any[]): void {
    const eventListeners = this.listeners.get(event);
    if (eventListeners) {
      eventListeners.forEach((callback) => {
        try {
          callback(...args);
        } catch (error) {
          console.error(`EventEmitter: Error in ${event} listener:`, error);
        }
      });
    }
  }

  public off(event: string, callback?: Function): void {
    if (!callback) {
      this.listeners.delete(event);
      return;
    }

    const eventListeners = this.listeners.get(event);
    eventListeners?.delete(callback);

    if (eventListeners?.size === 0) {
      this.listeners.delete(event);
    }
  }

  public removeAllListeners(event?: string): void {
    if (event) {
      this.listeners.delete(event);
    } else {
      this.listeners.clear();
    }
  }

  public listenerCount(event: string): number {
    return this.listeners.get(event)?.size ?? 0;
  }

  public eventNames(): string[] {
    return Array.from(this.listeners.keys());
  }
}
